import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { Menu, Layout, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { storeArq } from 'correos-arq-utils';
var Sider = Layout.Sider;

var MLateral = /*#__PURE__*/function (_Component) {
  _inherits(MLateral, _Component);

  var _super = _createSuper(MLateral);
  /*El proposito de este menu es estar sincronizado con el menu horizontal,
  puesto que representan a partir del 2 nivel de nav, es decir, con el primer subnivel
  en colaboración con la page abierta actualmente*/


  function MLateral(props) {
    var _this;

    _classCallCheck(this, MLateral);

    _this = _super.call(this, props); //Pasar de objeto JSON a componentes <Menu> a renderizar de forma recursiva

    _this.getSubmenus = function (items) {
      var res = [];

      for (var i = 0; i < items.childs.length; i++) {
        //Longitud actual max de los items es 17-20
        //console.log(this.props.t(items.childs[i].label) + ": " + this.props.t(items.childs[i].label).length);
        if (_this.props.t(items.childs[i].label).length <= _this.props.longItem) {
          if (items.childs[i].sub !== null && items.childs[i].sub.length > 0) {
            res.push( /*#__PURE__*/React.createElement(Menu.SubMenu, {
              className: "MenuTitle OverflowMenuTitle",
              key: items.childs[i].path + 'SubMenu',
              children: _this.getSubmenus({
                childs: items.childs[i].sub,
                parent: items.parent + items.childs[i].path
              }),
              title: i === 3 ?
              /*#__PURE__*/
              //pag de navegacion por tarjetas con link
              React.createElement(Link, {
                to: items.parent + items.childs[i].path,
                onClick: function onClick() {
                  return _this.props.reloadApp();
                },
                className: "SubMenuLink MenuTitle OverflowMenuTitle"
              }, _this.props.t(items.childs[i].label)) : /*#__PURE__*/React.createElement("p", {
                className: "SubMenuLink MenuTitle OverflowMenuTitle"
              }, _this.props.t(items.childs[i].label))
            }));
          } else {
            res.push( /*#__PURE__*/React.createElement(Menu.Item, {
              key: items.childs[i].path,
              onClick: function onClick() {
                return _this.props.reloadApp();
              }
            }, /*#__PURE__*/React.createElement(Link, {
              to: items.parent + items.childs[i].path,
              className: "MenuTitle OverflowMenuTitle"
            }, _this.props.t(items.childs[i].label))));
          }
        } else {
          // throw new Error("Ha excedido el número de caracteres permitidos");   
          for (var _i = 0; _i < items.childs.length; _i++) {
            // si tiene mas de 20 caracteres, que aparezca '...' y tooltip
            if (_this.props.t(items.childs[_i].label).length > _this.props.longItem) {
              if (items.childs[_i].sub !== null && items.childs[_i].sub.length > 0) {
                res.push( /*#__PURE__*/React.createElement(Menu.SubMenu, {
                  className: "MenuTitle OverflowMenuTitle",
                  key: _i,
                  children: _this.getSubmenus({
                    childs: items.childs[_i].sub,
                    parent: items.parent + items.childs[_i].path
                  }),
                  title: _i === 3 ?
                  /*#__PURE__*/
                  //pag de navegacion por tarjetas con link
                  React.createElement(Tooltip, {
                    title: _this.props.t(items.childs[_i].label),
                    placement: "rightTop"
                  }, /*#__PURE__*/React.createElement(Link, {
                    to: items.parent + items.childs[_i].path,
                    onClick: function onClick() {
                      return _this.props.reloadApp();
                    },
                    className: "SubMenuLink MenuTitle OverflowMenuTitle"
                  }, _this.props.t(items.childs[_i].label).substr(0, 20) + ' ...')) : /*#__PURE__*/React.createElement(Tooltip, {
                    title: _this.props.t(items.childs[_i].label),
                    placement: "rightTop"
                  }, /*#__PURE__*/React.createElement("p", {
                    className: "SubMenuLink MenuTitle OverflowMenuTitle"
                  }, _this.props.t(items.childs[_i].label).substr(0, 20) + ' ...'))
                }));
              } else {
                res.push( /*#__PURE__*/React.createElement(Menu.Item, {
                  key: _i,
                  onClick: function onClick() {
                    return _this.props.reloadApp();
                  }
                }, /*#__PURE__*/React.createElement(Tooltip, {
                  title: _this.props.t(items.childs[_i].label),
                  placement: "rightTop"
                }, /*#__PURE__*/React.createElement(Link, {
                  to: items.parent + items.childs[_i].path,
                  className: "MenuTitle OverflowMenuTitle"
                }, _this.props.t(items.childs[_i].label).substr(0, 20) + ' ...'))));
              }
            }
          }
        }
      }

      return res;
    }; //se carga el storeArq en el componente


    storeArq.load();
    _this.state = {
      auth: storeArq.data.auth
    };
    return _this;
  }

  _createClass(MLateral, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var items = this.getSubmenus(props.items);
      return /*#__PURE__*/React.createElement(Sider, {
        width: "auto",
        className: "MySider menu-lateral"
      }, /*#__PURE__*/React.createElement(Menu, {
        mode: "inline",
        theme: "light",
        className: "menu"
      }, items));
    }
  }]);

  return MLateral;
}(Component);

export default withTranslation()(MLateral);